import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";

export const footerData = [
  {
    label: "ERC & CG&C",
    link: "#",
    children: [
      { label: "About Us", link: "/about-us" },
      { label: "Learning Centre", link: "/" },
      { label: "ERC Store", link: "/" },
      { label: "Guidance & Counselling", link: "/" },
      { label: "Teachers Training", link: "/" },
    ],
  },
  {
    label: "Support",
    link: "#",
    children: [
      { label: "Help and Support", link: "/" },
      { label: "Become an Instructor", link: "/be-instructor" },
      { label: "Terms & Conditions", link: "/terms" },
      { label: "Support", link: "/" },
      { label: "FaQs", link: "/faq" },
    ],
  },
];

const iconClass = "w-5 h-5";

export const socials = [
  { id: 1, icon: FaFacebookF, alt: "facebook-logo", link: "#" },
  { id: 2, icon: FaInstagram, alt: "instagram-logo", link: "#" },
  { id: 3, icon: FaLinkedinIn, alt: "linkedin-logo", link: "#" },
  { id: 4, icon: FaTwitter, alt: "twitter-logo", link: "#" },
];